// Origens públicas dos dois sites, injetadas pelo backend em window.__RP_ORIGINS__
// (app/core/origins.py, marcador <!--rp:boot--> do index.html). Em staging apontam para a
// stack nova; o fallback é produção. Logos/uploads continuam em produção (só existem lá).
declare global {
  interface Window {
    __RP_ORIGINS__?: { appradio?: string; radios?: string };
  }
}

const injected = typeof window !== "undefined" ? window.__RP_ORIGINS__ : undefined;

export const APPRADIO_ORIGIN = injected?.appradio ?? "https://appradio.pro";
export const RADIOS_ORIGIN = injected?.radios ?? "https://radios.pro";
